
import React, { createContext, useState, useCallback } from 'react';

export const ScaleContext = createContext();

export const ScaleProvider = ({ children }) => {
  const [scale, setScale] = useState(1);
  const [isCentered, setIsCentered] = useState(false);

  const increaseScale = useCallback(() => {
    setScale(prevScale => prevScale * 1.1);
  }, []);

  const decreaseScale = useCallback(() => {
    setScale(prevScale => prevScale / 1.1);
  }, []);

  const resetScale = useCallback(() => {
    setIsCentered(true);
    setTimeout(() => setIsCentered(false), 0);
  }, [])  

  return (
    <ScaleContext.Provider value={{ scale, increaseScale, decreaseScale, resetScale, isCentered }}>
      {children}
    </ScaleContext.Provider>
  );
};
